(function($) {
    $('.panel-collapse.collapse').on('shown.bs.collapse', function (e) {
        if (!$(this).is(e.target)) return;
        $(this).prev().find('.chevron_toggleable').addClass('fa-angle-down').removeClass('fa-angle-right');
        $(this).prev().find('.plus_toggleable').addClass('fa-minus').removeClass('fa-plus');
 
        if($(this).attr('id')=='collapseEarnFreeFoods'){
           $("#panelInviteFriends h4 #invite_frindtextchange ").html("");
           $("#panelInviteFriends h4 #invite_frindtextchange ").html("Invite Friends");
        } else if($(this).attr('id')=='collapseFriends'){
          $("#panelInviteFriends h4 #invite_frindtextchange ").html("");
          $("#panelInviteFriends h4 #invite_frindtextchange ").html("<span class = 'plus_toggleable fa fa-plus'></span>Connect with Friends");
        }
    });
    $('.panel-collapse.collapse').on('hidden.bs.collapse', function (e) {
        if (!$(this).is(e.target)) return;
        $(this).prev().find('.chevron_toggleable').addClass('fa-angle-right').removeClass('fa-angle-down');
        $(this).prev().find('.plus_toggleable').addClass('fa-plus').removeClass('fa-minus');
    });
}(jQuery));